import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="11.755"
      height="15.673"
      x=".122"
      y=".735"
      fill="#FFBC00"
      stroke="#051045"
      rx="1"
      transform="translate(7 5)"
    />
  </svg>
);

const IconYellowCardWithoutHand: React.FC<IIcon> = (props: ReactProps) => <Icon {...props} svg={svg} />;

export default IconYellowCardWithoutHand;
